import { WebChatBotAccountModel } from "@jugl-web/rest-api";
import { createContext } from "react";

export interface WebChatBotAccountContextType {
  webChatBotAccount: WebChatBotAccountModel | undefined;
  isConnected: boolean;
  isConnectingWebChatBotAccount: boolean;
  connectWebChatBotAccount: () => Promise<void>;
  toggleWebChatBotAccount: () => void;
  isToggleWebChatBotAccountLoading: boolean;
}

export const WebChatBotAccountContext =
  createContext<WebChatBotAccountContextType | null>(null);
